import React, { Component } from "react";
import ButtonRecuperar from "./ButtonRecuperar";
import ButtonBloqueo from "./ButtonBloqueo";
import ButtonReImprimir from "./ButtonReImprimir";
import ButtonBaja from "./ButtonBaja";
import ButtonMostrarEdicion from "./ButtonMostrarEdicion";
import ButtonConfirmador from "./ButtonConfirmador";

class TableRow extends Component {
    constructor(props) {
        super(props);

        /*Bindings de metodos a la clase*/
        this.formatearVencimiento = this.formatearVencimiento.bind(this);
        this.armarDescripcionLimite = this.armarDescripcionLimite.bind(this);
    }
    /**
     * 
     * @param {any} vencimiento Parametro string, representa la fecha de vencimiento de la tarjeta. Formato YYYYMM
     */
    formatearVencimiento(vencimiento) {
        return ((vencimiento) ? vencimiento.substring(6, 4) + "/" + vencimiento.substring(0, 4) : "");
    }
    /**
     * Arma la descripcion del limite de compra para la tarjeta
     * @param {any} porcentajeLimiteCompra
     * @param {any} modalidadDistribucionLimiteId
     */
    armarDescripcionLimite(porcentajeLimiteCompra, modalidadDistribucionLimiteId, valorCuenta) {
        if (modalidadDistribucionLimiteId == 1) {
            return "SIN LIMITES"
        } else {
            return porcentajeLimiteCompra + "% (" + ((porcentajeLimiteCompra * valorCuenta) / 100) + ")";
        }
    }
    /**
     * 
     */
    render() {
        const { data, filaEnModoEdicion, novedad, tarjeta, puedeEjecutar } = this.props;
        const { actualizarNovedadEstado, guardarNovedadBloqueo, mostrarFilaEnModoEdicion, selectCombo } = this.props;
        const claseTieneNovedad = ((novedad.existeNovedad && data.funcionesDelUsuario.Confirmacion == true) ? "fila-con-novedad-tarjetas" : "");

        return (
            <tr key={"table-row-tarjeta-" + tarjeta.TarjetaCreditoId} className={claseTieneNovedad}>
                <td className="default-td">
                    {tarjeta.TarjetaCreditoNumero}</td>

                <td className="default-td">
                    {tarjeta.Denominacion}</td>

                <td className="default-td">
                    {tarjeta.TarjetaTipoDescripcion}</td>

                <td className="default-td">
                    {this.armarDescripcionLimite(tarjeta.PorcentajeLimiteCompra, tarjeta.ModalidadDistribucionLimiteId, data.cuentaDatos.Valor)}</td>

                <ButtonRecuperar
                    codigoNovedad="RECUP_TARJ"
                    entidadTipo={data.entidadTipo}
                    funcionesDelUsuario={data.funcionesDelUsuario}
                    novedad={novedad}
                    puedeEjecutar={puedeEjecutar}
                    tarjeta={tarjeta}

                    actualizarNovedadEstado={actualizarNovedadEstado}
                    guardarNovedadBloqueo={guardarNovedadBloqueo} />

                {/*<td className="default-td">
                    {this.formatearVencimiento(tarjeta.Vencimiento)}</td>*/}

                <td className="producto-tarjeta">
                    <div className="container-iconos">
                        {/*<div className="custom-icono">
                            <ButtonBloqueo
                                codigoNovedad="BLOQU_TARJ"
                                entidadTipo={data.entidadTipo}
                                novedad={novedad}
                                tarjeta={tarjeta} motivos={data.motivosBloqueo}

                                actualizarNovedadEstado={actualizarNovedadEstado}
                                guardarNovedadBloqueo={guardarNovedadBloqueo}
                                selectCombo={selectCombo} />
                        </div>*/}

                        <div className="custom-icono">
                            <ButtonBaja
                                codigoNovedad="BAJA_TARJ"
                                entidadTipo={data.entidadTipo}
                                novedad={novedad}
                                motivos={data.motivosBaja}
                                puedeEjecutar={puedeEjecutar}
                                tarjeta={tarjeta}

                                actualizarNovedadEstado={actualizarNovedadEstado}
                                guardarNovedadBloqueo={guardarNovedadBloqueo}
                                selectCombo={selectCombo} />
                        </div>

                        <div className="custom-icono">
                            <ButtonReImprimir
                                novedad={novedad}
                                puedeEjecutar={puedeEjecutar}
                                tarjeta={tarjeta} />
                        </div>

                        {(novedad.existeNovedad == true && data.funcionesDelUsuario.Confirmacion == true) &&
                            <ButtonConfirmador />}

                        <div className="custom-icono">
                            <ButtonMostrarEdicion
                                novedad={novedad}
                                filaEnModoEdicion={filaEnModoEdicion}
                                puedeEjecutar={puedeEjecutar}
                                tarjeta={tarjeta}

                                mostrarFilaEnModoEdicion={() => mostrarFilaEnModoEdicion(tarjeta.TarjetaCreditoId, filaEnModoEdicion)} />
                        </div>
                    </div>
                </td>
            </tr>
        );
    }
}

export default TableRow;